import { render, staticRenderFns } from "./PayBoxSidebar.vue?vue&type=template&id=a5052d8a&scoped=true&"
import script from "./PayBoxSidebar.vue?vue&type=script&lang=js&"
export * from "./PayBoxSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PayBoxSidebar.vue?vue&type=style&index=0&id=a5052d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5052d8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5052d8a')) {
      api.createRecord('a5052d8a', component.options)
    } else {
      api.reload('a5052d8a', component.options)
    }
    module.hot.accept("./PayBoxSidebar.vue?vue&type=template&id=a5052d8a&scoped=true&", function () {
      api.rerender('a5052d8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/PayBoxSidebar.vue"
export default component.exports